import { createApp } from "vue";
import { router } from "./router/RouteManager";

import "../../ui/src/assets/styles/index.css";
import "../../ui/src/assets/styles/colors.css";
import "./svws-laufbahnplanung.css";

import SWrapper from "~/components/SWrapper.vue";

const app = createApp(SWrapper);
app.use(router);

app.mixin({
	created() {
		const title = this.$options.title;
		if (title !== undefined)
			document.title = title;
	}
});
router.isReady()
	.then(() => app.mount("#app"))
	.catch((e: unknown) => { throw e });
